import React, { useContext } from "react";
import LoggedIn from "./LoggedIn";
import { LoginContext } from "../../../lib/context";

const UserProfile = () => {
  const { login, setLogin } = useContext(LoginContext);

  console.log(login);

  return (
    <div className="flex flex-col justify-center items-center mt-2.5 gap-y-6">
      {login ? (
        <LoggedIn />
      ) : (
        <button
          // onClick={}
          type="button"
          className="focus:outline-none text-white bg-pinkColor hover:bg-red-800 focus:ring-4 focus:ring-red-300 rounded-lg text-sm uppercase font-semibold px-14 py-4 me-2 mb-2 dark:bg-red-600 dark:hover:bg-red-700 dark:focus:ring-red-900 w-4/12"
        >
          Login please
        </button>
      )}
    </div>
  );
};

export default UserProfile;
